

<template>
    <div class="grid scroll-div ">
        <div class="grid-title bg-primary">
            <h4 class="text-bold text-white">
                Availability overrides
            </h4>
            <FabricCalculationInfo v-if="activeTab == 'alwaysAvailable'">
                <template #title>This is a list of fabric that is always available.</template>
                <template #content>
                    <div class="calculation-info-container">
                        <div class="title">Reserved stock</div>
                        <div class="description">eserved stock is the sum of fabric cut length ( <i>In Percent</i> )</div>
                        <code>
                            $fabricCutLength = $fabricCutLengthForEachOrder; <br/>
                            $fabricCutLengthForAllOrders = sum($fabricCutLength) <br/>
                            $result = ($fabricCutLengthForAllOrders / $inStockLength) * 100;
                        </code>
                    </div>
                    
                    <div class="calculation-info-container">
                        <div class="title">Free stock</div>
                        <div class="description">Free stock is the length ( <i>In Meter</i> ) of fabric that is remaining.</div>
                        <code>
                            $fabricCutLength = $fabricCutLengthForEachOrder; <br/>
                            $fabricCutLengthForAllOrders = sum($fabricCutLength) <br/>
                            $result = $inStockLength - $fabricCutLengthForAllOrders;
                        </code>
                    </div>
    
                    <div class="calculation-info-container">
                        <div class="title">Est. Sold out date</div>
                        <div class="description">Estimated sold out date is the date when the fabric is expected to be sold out or unavailable for purchase.</div>
                        <code>
                            const LENGTH_UNTIL_SOLD_OUT_STATUS_TRIGGERED = 30;<br/>
                            $average = max($averageUsage30days, $averageUsage60days, $averageSale30days, $averageSale60days);<br/>
                            $daysLeftForStock = ($fabricInStock - LENGTH_UNTIL_SOLD_OUT_STATUS_TRIGGERED) / $average;<br/>
                            $result = formatDaysToDate($daysLeftForStock);
                        </code>
                    </div>
                </template>
            </FabricCalculationInfo>
        </div>
        <div class="tabs">
            <div @click="activeTab = 'alwaysAvailable'" class="tab" :class="{'active': activeTab == 'alwaysAvailable'}">
                Always available
            </div>
            <div @click="activeTab = 'piecesAvailable'" class="tab" :class="{'active': activeTab == 'piecesAvailable'}">
                Pieces available
            </div>
        </div>
        <div class="grid-body p-0 height-360">
            <table class="table table-bordered">
                <thead v-if="activeTab == 'alwaysAvailable'">
                    <tr>
                        <th class="pointer" @click="sort('id')" width="150">
                            Fabric
                            <i class="fa fa-sort" aria-hidden="true"></i>
                        </th>
                        <th class="text-center pointer" @click="sort('reserved_stock')" width="130">
                            Reserved stock 
                            <i class="fa fa-sort" aria-hidden="true"></i>
                        </th>
                        <th class="text-center pointer" @click="sort('available_stock')" width="120">
                            Free Stock 
                            <i class="fa fa-sort" aria-hidden="true"></i>
                        </th>
                        <th class="text-center pointer" @click="sort('out_of_stock_date')" width="150">
                            Est. Sold out date
                            <i class="fa fa-sort" aria-hidden="true"></i>
                        </th>
                        <th class="text-center pointer" @click="sort('placed_order')" width="120">
                            Placed order (yes/no)
                            <i class="fa fa-sort" aria-hidden="true"></i>
                        </th>
                    </tr>
                </thead>
                <thead v-if="activeTab == 'piecesAvailable'">
                    <tr>
                        <th class="pointer" @click="sort('id')" width="150">
                            Fabric
                            <i class="fa fa-sort" aria-hidden="true"></i>
                        </th>
                        <th class="text-center pointer" @click="sort('pieces_count')">
                            Pieces available
                            <i class="fa fa-sort" aria-hidden="true"></i>
                        </th>
                        <th class="text-center pointer" @click="sort('last_overwrite_date')">
                            Date last updated overwrite
                            <i class="fa fa-sort" aria-hidden="true"></i>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="activeTab == 'alwaysAvailable'" v-for="(fabric, index) in sortedFabrics.alwaysAvailable" :key="index">
                        <td><router-link :to="'/fabric/update/'+fabric.id"> {{$Fabric.getCode(fabric.id)}} - {{fabric.name}} </router-link></td>
                        <td class="text-center">{{fabric.reserved_stock_percent.toFixed(2)}} %</td>
                        <td class="text-center">{{fabric.in_stock.toFixed(2)}} m</td>
                        <td class="text-center">{{fabric.out_of_stock_date > 0 ? moment.unix(fabric.out_of_stock_date).format('DD MMM, YYYY') : '-'}}</td>
                        <td class="text-center">{{fabric.placed_order}}</td>
                    </tr>
                    <tr v-if="activeTab == 'piecesAvailable'" v-for="(fabric, index) in sortedFabrics.piecesAvailable" :key="index">
                        <td><router-link :to="'/fabric/update/'+fabric.id"> {{$Fabric.getCode(fabric.id)}} - {{fabric.name}} </router-link></td>
                        <td class="text-center">{{ fabric.pieces_count }}</td>
                        <td class="text-center">{{moment(fabric.last_overwrite_date).format('DD MMM, YYYY')}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import FabricCalculationInfo from "./FabricCalculationInfo"
export default {
    props: ['pageData'],
    components: {FabricCalculationInfo},
    data() {
        return {
            activeTab: 'alwaysAvailable',
            sortType : 'asc',
            sortedFabrics: {
                alwaysAvailable: [],
                piecesAvailable: [],
            },
        }
    },
    methods: {
        sort(column) {
            this.sortType = (this.sortType == 'asc') ? 'desc' : 'asc';
            this.sortedFabrics[this.activeTab] =  _.orderBy(this.sortedFabrics[this.activeTab], [column], [this.sortType]);
        },
    },
    watch: {
        'pageData.availabilityOverrides': function() {
            let availabilityOverrides = this.pageData.availabilityOverrides;
            if(availabilityOverrides) {
                this.sortedFabrics = availabilityOverrides;
                this.sortedFabrics.alwaysAvailable =  _.orderBy(availabilityOverrides.alwaysAvailable, 'out_of_stock_date', [this.sortType]);
                this.sortedFabrics.piecesAvailable = _.orderBy(availabilityOverrides.piecesAvailable, 'last_overwrite_date', [this.sortType])
            }
        }
    },
}
</script>

<style scoped lang="scss">
.tabs {
    display: flex;
    height: 40px;
    align-items: center;
    background-color: #5e72e4;
    border-bottom: 1px solid white;
    padding: 20px;
}
.tabs .tab {
    color: white;
    font-weight: bold;
    display: flex;
    height: 30px;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    padding: 0 20px;
    cursor: pointer;
    border-radius: 13px;
    border: 1px solid #ffffff58;
}
.tabs .tab:not(:first-child) {
    margin-left: 10px;
}
.tabs .tab:hover {
    background-color: #838282a3;
}
.tabs .tab.active {
    color: #5e72e4;
    background-color: white;
    border-color: white;
}
.height-360 {
    height: 360px !important;
}

.grid-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 52px;

    h4 {
        margin-top: 0;
    }
}
</style>